import { render, staticRenderFns } from "./TournamentRules.vue?vue&type=template&id=2e60a38a&scoped=true"
import script from "./TournamentRules.vue?vue&type=script&lang=js"
export * from "./TournamentRules.vue?vue&type=script&lang=js"
import style0 from "./TournamentRules.vue?vue&type=style&index=0&id=2e60a38a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e60a38a",
  null
  
)

export default component.exports